// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3Bnfe","boxTitle":"Qualiphy_boxTitle__1fEyO","box":"Qualiphy_box__3hMYP","toggleWrap":"Qualiphy_toggleWrap__3rHe1"};